import Layout from "../components/Layout/Layout";
import RequirementForm from "../components/RequirementForm";
import LoginContainer from "./LoginContainer";
const Requirement = () => {
  const user = JSON.parse(window.localStorage.getItem("user"));
  if (user) {
    return (
      <Layout user={user}>
        <RequirementForm user={user} />
      </Layout>
    );
  } else {
    return <LoginContainer />;
  }
};
export default Requirement;